import React, { useState } from 'react';
import DateInput from './DateInput';
import { MESES_ES } from '../../utils/dateUtils';
import { LuSearch } from 'react-icons/lu';

function formatMes(ym) {
    if (!ym) return '';
    const [y, m] = ym.split('-');
    return `${MESES_ES[parseInt(m)]} ${y}`;
}

// Barra segmentada unida
function SegmentBar({ items, value, onChange }) {
    return (
        <div className="flex rounded-lg overflow-hidden shadow-sm border border-black/[0.05] dark:border-white/[0.05]">
            {items.map((item, i) => (
                <button key={item.value} onClick={() => onChange(item.value)}
                    className={`flex-1 h-8 text-label font-bold uppercase transition-all active:scale-[0.98] ${
                        value === item.value
                            ? 'bg-brand-red text-white z-[1]'
                            : 'bg-white dark:bg-[#161615] text-muted'
                    } ${i > 0 ? 'border-l border-black/[0.05] dark:border-white/[0.05]' : ''}`}>
                    {item.label}
                </button>
            ))}
        </div>
    );
}

const RAPIDOS = [{ value: 'TODO', label: 'Todo' }, { value: '7', label: '7 días' }, { value: '30', label: '30 días' }, { value: '60', label: '60' }, { value: '90', label: '90' }];
const chip = (on) => `shrink-0 h-9 px-3 rounded-xl text-label font-black border active:scale-95 ${on ? 'bg-[#C9341F] text-white border-transparent' : 'bg-card text-secondary border-black/[0.06] dark:border-white/[0.08]'}`;

export default function FiltrosPanel({ estados = [], conBusqueda = false, conRango = true, placeholderBusqueda = 'Buscar...', hook }) {
    const {
        busqueda, setBusqueda,
        estado, setEstado,
        periodoRapido, aplicarRapido,
        mesSelector, aplicarMesSelector,
        desde, hasta, aplicarRango,
        mesesDisponibles,
        totalItems, pagina, totalPaginas,
    } = hook;

    const [otro, setOtro] = useState(false);
    const [desdeLocal, setDesdeLocal] = useState('');
    const [hastaLocal, setHastaLocal] = useState('');


    return (
        <div className="space-y-2">

            {/* Búsqueda */}
            {conBusqueda && (
                <div className="relative">
                    <LuSearch size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted pointer-events-none" />
                    <input type="text" placeholder={placeholderBusqueda}
                        value={busqueda} onChange={e => setBusqueda(e.target.value)}
                        className="w-full h-9 pl-9 pr-8 rounded-lg text-body outline-none bg-card text-ink placeholder-muted shadow-sm border border-black/[0.05] dark:border-white/[0.05] focus:border-[#D13A28] dark:focus:border-[#E8422F]" />
                    {busqueda && (
                        <button onClick={() => setBusqueda('')}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted text-label font-bold">✕</button>
                    )}
                </div>
            )}

            {/* Período (1-nov-2026): igual que Finanzas: Todo · 7 · 30 · 60 · 90 días · Otro ▾ (un mes o desde–hasta) */}
            <div className="flex gap-1.5 overflow-x-auto pb-0.5 -mx-1 px-1">
                {RAPIDOS.map(r => (
                    <button key={r.value} type="button" onClick={() => { aplicarRapido(r.value); setOtro(false); }}
                        className={chip(String(periodoRapido) === r.value && !mesSelector)}>{r.label}</button>
                ))}
                <button type="button" onClick={() => setOtro(v => !v)}
                    className={chip(otro || mesSelector || !RAPIDOS.some(r => r.value === String(periodoRapido)))}>Otro ▾</button>
            </div>
            {otro && (
                <div className="p-3 rounded-2xl bg-card border border-black/[0.06] dark:border-white/[0.08] space-y-2.5">
                    <div className="flex items-center gap-2">
                        <span className="w-16 shrink-0 text-caption font-bold text-muted">Un mes</span>
                        {mesesDisponibles?.length > 0 ? (
                            <select value={mesSelector} onChange={e => { aplicarMesSelector(e.target.value); if (e.target.value) setOtro(false); }}
                                className="flex-1 min-w-0 h-10 px-3 rounded-xl bg-chip text-ink text-body font-bold outline-none">
                                <option value="">Elegir…</option>
                                {mesesDisponibles.map(m => <option key={m} value={m}>{formatMes(m)}</option>)}
                            </select>
                        ) : <span className="text-caption text-muted">Sin meses con datos</span>}
                    </div>
                    {conRango && (<>
                        <div className="flex items-center gap-2">
                            <span className="w-16 shrink-0 text-caption font-bold text-muted">Desde</span>
                            <DateInput value={desdeLocal} onChange={setDesdeLocal} className="flex-1 min-w-0 h-10 px-2 rounded-xl bg-chip text-ink text-body font-bold outline-none" />
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="w-16 shrink-0 text-caption font-bold text-muted">Hasta</span>
                            <DateInput value={hastaLocal} onChange={setHastaLocal} className="flex-1 min-w-0 h-10 px-2 rounded-xl bg-chip text-ink text-body font-bold outline-none" />
                            <button type="button" onClick={() => { if (desdeLocal || hastaLocal) { aplicarRango(desdeLocal, hastaLocal); setOtro(false); } }}
                                className="h-10 px-3 rounded-xl bg-ink text-page text-label font-black active:scale-95">Ver</button>
                        </div>
                    </>)}
                </div>
            )}

            {/* Estado — barra segmentada */}
            {estados.length > 0 && (
                <SegmentBar
                    items={[{ value: 'TODOS', label: 'Todos' }, ...estados]}
                    value={estado}
                    onChange={setEstado}
                />
            )}
        </div>
    );
}
